import { render, staticRenderFns } from "./conf_page.vue?vue&type=template&id=10cce1bc&scoped=true&"
import script from "./conf_page.vue?vue&type=script&lang=js&"
export * from "./conf_page.vue?vue&type=script&lang=js&"
import style0 from "./conf_page.vue?vue&type=style&index=0&id=10cce1bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cce1bc",
  null
  
)

export default component.exports